import { render, staticRenderFns } from "./CallCard.vue?vue&type=template&id=196b7dde&scoped=true"
import script from "./CallCard.vue?vue&type=script&lang=js"
export * from "./CallCard.vue?vue&type=script&lang=js"
import style0 from "./CallCard.vue?vue&type=style&index=0&id=196b7dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b7dde",
  null
  
)

export default component.exports